import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import getTabStyle from './styles/style';
import { useSelector } from 'react-redux';
import Chip from '@mui/material/Chip';
import { COLOR_PRIMARY_2 } from 'src/colors';

const TabBar = ({
  tabList,
  currentTab,
  color,
  renderLabelCondition,
}: {
  tabList;
  currentTab;
  color;
  renderLabelCondition;
}) => {
  const renderLabel = renderLabelCondition();
  const userCountryCode = useSelector(state => (state as any).dashboard.userCountryCode);
  let styles = getTabStyle(color);

  return (
    <Box sx={styles.root}>
      <Tabs value={currentTab} sx={styles.tabs} variant="scrollable" scrollButtons={false}>
        {tabList.map(currentTab => (
          <Tab
            icon={currentTab.icon}
            // label={renderLabel ? currentTab.label : ''}
            label={
              <span>
                {renderLabel ? currentTab.label : ''}
                {(currentTab.label == 'Discovery' || currentTab.label == 'Compare') && <Chip
                  label="Global"
                  sx={{ color: `${COLOR_PRIMARY_2}`, border: `1px solid ${COLOR_PRIMARY_2}`, marginLeft:'2px', marginTop:'2px', fontSize:'12px',height:'20px' }}
                  variant="outlined"
                  size="small"
                />}
              </span>
            }
            value={currentTab.value}
            iconPosition="start"
            sx={styles.tab}
            onClick={currentTab.onclick}
            wrapped
            // disabled={
            //   userCountryCode != 'US' &&
            //   (currentTab.value == 'discovery' || currentTab.value == 'compare')
            //     ? true
            //     : false
            // }
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default TabBar;
